export default __webpack_public_path__ + "static/media/info-bg.97adfe15.jpg";